import React, { useState, useEffect } from 'react'
import { HiPencil } from 'react-icons/hi'
import TextAreaEditor from '../../../../../components/Form/TextAreaEditor'
import { CgClose } from 'react-icons/cg'
import Modal from '../../../../../components/Modal'
import axios from 'axios'
import {RESUME_API_END_POINT} from "../../../../../utils/constant"
import { useSelector } from "react-redux"
import { useOutletContext } from 'react-router-dom'

const Bio = ({data, setData}) => {
    const [showBioModal, setShowBioModal] = useState(false);
    const [bio, setBio] = useState(data?.bio || "")
    const [isSaving, setIsSaving] = useState(false);
    const {user} = useSelector(store=>store.user)
     const {showNotif, setShowNotif} = useOutletContext()

    useEffect(() => {
        if (data) {
          setBio(data?.bio)
        }
      }, [data])

    const handleSaveBio = async () => {
        setIsSaving(true)
        // try {
            await axios.put(RESUME_API_END_POINT+'/bio/save/'+user?.id, { bio })
            .then((response) =>{
                setBio(response.data.bio) // Update bio with response
                setShowNotif({...showNotif, variant: "success", message:"Connexion réussie !", show: true}) 
                setShowBioModal(false)
            })
            .catch( (error)=>{
                console.error("Failed to update bio:", error);
                alert("An error occurred while updating your bio.")})
            .finally (()=>{
                setIsSaving(false)
            })
    }

    return (
        <div className="flex-col text-start border p-4 rounded-md">
            <div className="flex justify-between items-center mb-4">
                <div className="font-semibold">Bio</div>
                <button onClick={() => setShowBioModal(true)} className="bg-neutral-50 border rounded-sm p-1">
                    <HiPencil className="w-5 h-5 text-neutral-500" />
                </button>
            </div>
            <p className="text-primary-text"   dangerouslySetInnerHTML={{ __html: bio }}></p>

            {/* Modal for editing bio */}
            <Modal isOpen={showBioModal} onClose={() => setShowBioModal(false)}>
                <div className="flex items-center justify-between py-2 px-4">
                    <p>Modifier la biographie</p>
                    <button onClick={() => setShowBioModal(false)} className="px-2 py-2 rounded-md border text-primary-black">
                        <CgClose />
                    </button>
                </div>
                <hr className="mb-6" />
                <div className="px-6 space-y-4 mb-4">
                    <TextAreaEditor 
                        label="Bio" 
                        value={bio} 
                        setValue={setBio} 
                    />
                </div>
                <div className="flex items-center justify-end p-6">
                    <button onClick={handleSaveBio} disabled={isSaving} className="py-2 px-6 rounded-sm shadow bg-primary-black text-white">
                        {isSaving ? 'Saving...' : 'Enregistrer'}
                    </button>
                </div>
            </Modal>
        </div>
    );
};

export default Bio;
